import styled from 'styled-components';
import { Checkbox as AntdCheckbox } from 'components/atoms/checkbox';
import { Caption01 } from 'components/styles';

export const Label = styled.div`
  display: flex;
  align-items: center;
`;
export const Checkbox = styled(AntdCheckbox)`
  display: flex;
  align-items: center;
`;
export const CheckboxGroup = styled(Checkbox.Group)`
  .ant-checkbox-group-item {
    display: flex;
    align-items: center;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    box-shadow: var(--shadow-highlight)
      rgba(var(--blue-60-in-rgb), var(--shadow-highlight-color-opacity));
  }
  .ant-checkbox-checked.ant-checkbox-disabled .ant-checkbox-inner {
    box-shadow: var(--shadow-highlight)
      rgba(224, 224, 224, var(--shadow-highlight-color-opacity));
  }
`;

export const Helptext = styled.div`
  ${Caption01};
  color: var(--gray-100);
  opacity: 0.7;
`;
